/**
 * Client-side javascript to power modal dialogs.
 */

/** The body elemenet. */
const bodyEl = document.querySelector('body');

/** A list of ids of currently open modals. */
const openIds: string[] = [];

/**
 * Opens a modal with the given id.
 */
function openModal(id: string) {
  const modalEl = document.querySelector(`#${id}`) as HTMLElement;
  if (!modalEl) {
    console.warn(`Could not find modal with id ${id}`);
    return;
  }

  openIds.push(id);
  modalEl.classList.remove('hidden');
  bodyEl.classList.add('modal-active');
  modalEl.focus();
}

/**
 * Closes a modal with the given id.
 */
function closeModal(id: string) {
  const modalEl = document.querySelector(`#${id}`);
  if (!modalEl) {
    console.warn(`Could not find modal with id ${id}`);
    return;
  }

  modalEl.classList.add('hidden');

  const index = openIds.indexOf(id);
  if (index > -1) {
    openIds.splice(index, 1);
  }

  if (openIds.length === 0) {
    bodyEl.classList.remove('modal-active');
  }
}

/**
 * Listens to elements that will open a modal dialog.
 */
function setupTriggerEventListeners() {
  const triggerEls = Array.from(document.querySelectorAll('[modal-trigger]'));

  for (const triggerEl of triggerEls) {
    const targetId = triggerEl.attributes.getNamedItem('modal-trigger')?.value;
    triggerEl.addEventListener('click', () => {
      openModal(targetId);
    });
  }
}

/**
 * Listens to events with a modal dialog that will close it.
 */
function setupModalEventListeners() {
  const modalEls = Array.from(document.querySelectorAll('.modal'));
  for (const modalEl of modalEls) {
    const id = modalEl.id;

    // Clicking on the backdrop should close the modal
    modalEl.addEventListener('click', (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest('.modal-content')) {
        closeModal(id);
      }
    });

    // Clicking on the close button should close the modal
    const closeBtn = modalEl.querySelector('.btn.modal-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        closeModal(id);
      });
    }
  }

  // Pressing esc should dismiss the most recently opened mdoal
  bodyEl.addEventListener('keydown', (event: KeyboardEvent) => {
    if (event.key === 'Escape' && openIds.length > 0) {
      const id = openIds[openIds.length - 1];
      closeModal(id);
    }
  });
}

// Moves any modals to the body root.
function moveModalsToRoot() {
  const modalEls = Array.from(document.querySelectorAll('.modal'));
  for (const el of modalEls) {
    el.remove();
    bodyEl.appendChild(el);
  }
}

export function setupModalComponent() {
  moveModalsToRoot();
  setupModalEventListeners();
  setupTriggerEventListeners();
}

export default '';
